var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',[_vm._v("¥")]),_c('span',[_vm._v(_vm._s((_vm.price/100).toFixed(2)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }